import dynamic from 'next/dynamic';
import useModalStore from './useModalStore';
import useGTAG from './useGTAG';

const NotificationModal = dynamic(
  () => import('src/shared-components/NotificationModal/NotificationModal'),
  {
    ssr: false
  }
);

export const useModalHooks = () => {
  const { trackGtagEvent } = useGTAG();
  const { notificationModal, updateModalsConfig, setNotificationModal } =
    useModalStore();

  if (!notificationModal) {
    return null;
  }

  return (
    <NotificationModal
      key={notificationModal.translitName}
      onCloseCallback={(isFirstStep) => {
        updateModalsConfig(
          `notification-modal-${notificationModal.translitName}`,
          false
        );
        setTimeout(() => {
          setNotificationModal(null);
          if (!isFirstStep) {
            trackGtagEvent(
              `${notificationModal.gtagPrefix}_item_inform_ty_x`,
              notificationModal.name
            );
          }
        }, 250);
      }}
      drugName={notificationModal.name}
      drugId={notificationModal.id}
      modalId={`notification-modal-${notificationModal.translitName}`}
      gtagPrefix={notificationModal.gtagPrefix}
    />
  );
};
